import { isLoggedEstateRole } from './isEstateRole';

export const isBackOfficeUser = (): boolean => {
  return !isLoggedEstateRole();
};
